import { useRef } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryScroll() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: "left" | "right") => {
    if (!scrollRef.current) return;
    const amount = 340;
    scrollRef.current.scrollBy({
      left: direction === "left" ? -amount : amount,
      behavior: "smooth",
    });
  };

  return (
    <section className="relative py-16 md:py-20 bg-background-100">
      <div className="px-6 md:px-10">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground-900">
              Browse by <span className="text-primary-600">Category</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              14 curated categories — updated daily with fresh spreadsheet finds
            </p>
          </div>
          <span className="hidden md:inline-flex items-center px-4 py-1.5 text-xs font-medium rounded-full bg-foreground-900 text-white whitespace-nowrap">
            14 Categories
          </span>
        </div>

        <div className="relative">
          <button
            onClick={() => scroll("left")}
            className="absolute -left-3 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50 border border-background-200 text-foreground-600 hover:text-foreground-900 hover:border-foreground-300 transition-all shadow-sm"
          >
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>

          <div
            ref={scrollRef}
            className="flex gap-4 overflow-x-auto pb-2"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {categories.map((cat, idx) => (
              <a
                key={cat.id}
                href={cat.link}
                target="_blank"
                rel="noopener nofollow"
                className="flex-shrink-0 w-[280px] bg-background-50 rounded-lg overflow-hidden group hover:scale-[1.02] transition-transform duration-300"
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={cat.cardImageUrl}
                    alt={`${cat.name} pandabuyspreadsheet category`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 flex items-center justify-between">
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900">{cat.name}</h3>
                    <p className="text-xs text-foreground-500 mt-0.5">{cat.description}</p>
                  </div>
                  <span className="text-2xl font-bold text-foreground-200 group-hover:text-primary-400 transition-colors">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                </div>
              </a>
            ))}
          </div>

          <button
            onClick={() => scroll("right")}
            className="absolute -right-3 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50 border border-background-200 text-foreground-600 hover:text-foreground-900 hover:border-foreground-300 transition-all shadow-sm"
          >
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
        </div>
      </div>
    </section>
  );
}